import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-nav-cliente',
  templateUrl: './nav-cliente.component.html',
  styleUrls: ['./nav-cliente.component.scss']
})
export class NavClienteComponent implements OnInit {
  enviroment = environment.BASE_URL;
  clienteId;
  datosCliente;
  respuestaGet:any;
  tokenActual:any;

  constructor(private router: Router, private _get:LoginService) { }

  ngOnInit(): void {
    this.getDataCliente();
  }

  getDataCliente(){
    this._get.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
          if(this.datosCliente.is_staff == true){
            this.router.navigate(['clientes']);
          }
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  redirigirAPagos(){
    this.router.navigate(['/perfil/realizar-pago']);
  }

  ngAfterViewChecked() {
    console.log(this.router.url);
    if (this.router.url === '/perfil') {
      $('.nav-item').removeClass('active');
      $('#paqueteNav').addClass('active');
    }

    if (this.router.url === '/perfil/datos') {
      $('.nav-link').removeClass('active');
      $('#datosNav').addClass('active');
    }

    if (this.router.url === '/perfil/pagos') {
      $('.nav-item').removeClass('active');
      $('#pagosNav').addClass('active');
    }

    if (this.router.url === '/perfil/realizar-pago') {
      $('.nav-link').removeClass('active');
    }

    if (this.router.url === '/perfil/grupo') {
      $('.nav-item').removeClass('active');
      $('#grupoNav').addClass('active');
    }

    if (this.router.url === '/perfil/fotos') {
      $('.nav-item').removeClass('active');
      $('#fotosNav').addClass('active');
    }

    
  }

  async closeSesion() {
    this._get.cerrarSesion();
    await this.router.navigate(['']);
  }

}
